import { Component, OnInit, Output, Input } from '@angular/core';

@Component({
  selector: 'alert-content',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class GlobalAlertComponent implements OnInit {

  @Input() alert: any;
  @Output() onClose: any;

  constructor() {}

  ngOnInit(): void{}

  ngOnChanges(){}

  close(){
    this.onClose.emit(true);
  }

}
